import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import Lottie, { AnimationItem } from "lottie-web";
import { BehaviorSubject, Subject, takeUntil } from "rxjs";
import { PageLoadingService } from "src/services/page-loading.service";

@Component({
    selector: 'loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent implements OnInit, OnDestroy{
    private readonly onDestroy$ = new Subject<void>();
    private anim: AnimationItem;
    public modal: HTMLElement;
    private lottieInitialized = new BehaviorSubject<boolean>(false);

    constructor(
        public router: Router,
        private route: ActivatedRoute,
        public loadingService: PageLoadingService
    ){}

    ngOnInit(): void {
        this.anim = Lottie.loadAnimation({
            container: document.getElementById('loadingGraphic'),
            renderer: 'svg',
            rendererSettings: {
              className: 'loading-graphic'
            },
            loop: true,
            autoplay: false,
            path: '../../assets/loading_bubbles.json'
          });
      
          this.modal = document.getElementById('loadingModal');
      
          // Loading screen handler.
          // Loaded set to false everytime navigation starts, and set to true in component at the end of ngOnInit
          this.loadingService.pageLoaded$.pipe(takeUntil(this.onDestroy$)).subscribe((loaded) => {
            if(loaded){
                // console.log("    # Hiding")
              this.modal.style.display = "none";
              this.anim.stop();
            } else {
                // console.log("    # Displaying")
              this.modal.style.display = "flex";
              this.anim.play();
            }
          })
          this.lottieInitialized.next(true);
          this.modal.style.display = "flex";
          this.anim.play();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}